import type { StrictOmit } from '@enmon/commons';
import type { SorterResult } from 'antd/es/table/interface';
import { sortBy } from 'ramda';
import type { Sorter } from '../types/sorter';

/**
 * Antd table returns sorters in random order so we need to sort them by the order they were added
 */
export const transformSorters = (
  prevSorts: readonly Sorter[],
  sorters: ReadonlyArray<StrictOmit<SorterResult<unknown>, 'column'>>,
): Sorter[] => {
  const orderByFieldMap = new Map(prevSorts.map(({ field }, index) => [field, index + 1]));
  return sortBy(sorter => orderByFieldMap.get(sorter.columnKey?.toString() ?? '') ?? Number.MAX_SAFE_INTEGER, sorters)
    .map(sorter => ({
      field: sorter.columnKey?.toString() ?? '',
      order: sorter.order ?? null,
    }))
    .filter(({ field }) => field !== '');
};
